import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from '../../themes/ThemeProvider';
import styles from './HeaderDivider.module.css';
export const HeaderDivider = ({ className, style, height = 24, width = 1, color, ...props }) => {
    const theme = useTheme();
    const dividerColor = color || theme['header-divider-color'] || '#CCCCCC';
    const dividerStyle = {
        backgroundColor: dividerColor,
        width: `${width}px`,
        height: `${height}px`,
        ...style,
    };
    return (_jsx("div", { className: `${styles.divider} ${className || ''}`, style: dividerStyle, "data-testid": 'header-divider', ...props }));
};
export default HeaderDivider;
